export default __webpack_public_path__ + "static/media/warning--triple-reverse-curve-right--g1.0a1464ca.png";